import React, { useEffect, useMemo } from "react";
import x from "../../../assets/icons/x.svg";
import check from "../../../assets/icons/check.svg";
import { convertSatToBtc } from "../../../utils";
import { useUserStore } from "../../../store";
import Text from "../Text";
import InscriptionContent from "../InscriptionContent";
import TimeRemaining from "../../../modal/components/TimeRemaining";
import BtcUnits from "../BtcUnits";
import styles from "./AssetCard.module.css";

const AssetCard: any = React.forwardRef(
  (
    {
      assets,
      loan,
      hideHealth,
      onClick,
      onCancel,
      className,
      isSelected,
      hideId,
      noHover,
    }: {
      assets?: any;
      loan?: any;
      hideHealth?: boolean;
      onClick?: () => void;
      onCancel?: () => void;
      className?: string;
      isSelected?: boolean;
      hideId?: boolean;
      noHover?: boolean;
    },
    ref: React.Ref<HTMLAnchorElement | HTMLDivElement>,
  ) => {
    const isSat = useUserStore((state) => state.isSat);
    const ordAddress = useUserStore((state) => state.ordAddress);

    const due = useMemo(
      () => new Date(loan?.endDate ? +loan?.endDate : ""),
      [loan?.endDate],
    );
    const date = due.getDate();
    const month = due.toLocaleString("en-US", { month: "short" });
    const multipleAssets = assets ? assets.length > 1 : false;
    const isLoan = useMemo(
      () => loan?.principal && due && loan?.interestRate,
      [loan?.principal, due, loan?.interestRate],
    );

    return (
      <div
        ref={ref as any}
        className={`${styles.component}${className ? ` ${className}` : ""}${
          isSelected ? ` ${styles.selected}` : ""
        }${noHover ? ` ${styles.noHover}` : ""}`}
      >
        <div className={styles.content} onClick={onClick}>
          <InscriptionContent asset={assets[0]} />
          {!hideId && (
            <div className={styles.info}>
              <div className={styles.col}>
                <Text variant="Body2" color="White" className={styles.label}>
                  ID
                </Text>
                {isLoan && (
                  <>
                    <Text
                      variant="Body2"
                      color="White"
                      className={styles.label}
                    >
                      Amount
                    </Text>
                    <Text
                      variant="Body2"
                      color="White"
                      className={styles.label}
                    >
                      {loan?.endDate && loan.startDate ? "Due" : "Term"}
                    </Text>
                    <Text
                      variant="Body2"
                      color="White"
                      className={styles.label}
                    >
                      APR
                    </Text>
                  </>
                )}
              </div>
              <div className={styles.col}>
                <Text variant="Body2" color="White">
                  {multipleAssets
                    ? "Bundle"
                    : assets[0]?.inscriptionNumber
                    ? assets[0]?.inscriptionNumber
                    : assets[0]?.number}
                </Text>
                {isLoan && (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Text variant="Body2" color="White">
                        {convertSatToBtc(isSat, loan?.principal)}
                      </Text>
                      <BtcUnits style={{ marginLeft: 5 }} height={15} />
                    </div>
                    <Text variant="Body2" color="White">
                      {date && month ? `${date} ${month}` : `${loan.term} Days`}
                    </Text>
                    <Text variant="Body2" color="White">
                      {loan?.interestRate}%
                    </Text>
                  </>
                )}
              </div>
            </div>
          )}
          {hideHealth || loan?.status === "requested" ? (
            <></>
          ) : loan?.status === "pending" && loan?.lender?.id === ordAddress ? (
            <Text
              variant="Body2"
              color="Green"
              style={{ bottom: 7, position: "relative" }}
            >
              AWAITING BORROWER
            </Text>
          ) : loan?.status === "active" || loan?.status === "pending" ? (
            <div className={styles.cancel}>
              <TimeRemaining
                isSmall
                max={loan?.endDate ? +loan?.endDate : undefined}
                min={loan.startDate ? +loan.startDate : undefined}
              />
            </div>
          ) : (
            <Text
              variant="Body2"
              color="Green"
              style={{ bottom: 7, position: "relative" }}
            >
              {loan?.status?.toLocaleUpperCase()}
            </Text>
          )}
          {isSelected && <img className={styles.check} src={check} alt="" />}
        </div>
        {onCancel && loan?.status !== "activating" && (
          <div className={styles.cancel} onClick={onCancel}>
            <img src={x} alt="cancel" />
          </div>
        )}
      </div>
    );
  },
);

export default AssetCard;
